<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create GL Level 2</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateGlLevel2Form />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CreateGlLevel2Form from "../../components/Kleyton/Forms/GL/CreateGlLevel2Form";

export default {
  page: {
    title: "Create Gl Level 2",
    meta: [{ name: "Create Gl Level 2", content: window.__env.app.description }]
  },

  components: {
    CreateGlLevel2Form,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateGlLevel2",
      title: "Create Gl Level 2",
      items: [
        {
          text: "GlLevel2",
          href: "/"
        },
        {
          text: "Create Gl Level 2",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
